import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export const chipConfig = {
    skins: {
        lighten: {
            black: {
                fill: {
                    bg: ({ theme }) => theme.colors.tertiary.ultraLighten,
                    textColor: ({ theme }) => theme.colors.grey72,
                    border: ({ theme }) => theme.colors.tertiary.ultraLighten,
                },
                outline: {
                    border: ({ theme }) => theme.colors.tertiary.darken,
                    bg: ({ theme }) => theme.colors.tertiary.ultraLighten,
                    textColor: ({ theme }) => theme.colors.grey72,
                },
            },
            extra: {
                fill: {
                    bg: ({ theme }) => theme.colors.extra.ultraLighten,
                    textColor: ({ theme }) => theme.colors.extra.normal,
                    border: ({ theme }) => theme.colors.extra.ultraLighten,
                },
                outline: {
                    border: ({ theme }) => theme.colors.extra.normal,
                    bg: ({ theme }) => theme.colors.extra.ultraLighten,
                    textColor: ({ theme }) => theme.colors.extra.normal,
                },
            },
            secondary: {
                fill: {
                    bg: ({ theme }) => theme.colors.secondary.ultraLighten,
                    textColor: ({ theme }) => theme.colors.secondary.normal,
                    border: ({ theme }) => theme.colors.secondary.ultraLighten,
                },
                outline: {
                    border: ({ theme }) => theme.colors.secondary.normal,
                    bg: ({ theme }) => theme.colors.secondary.ultraLighten,
                    textColor: ({ theme }) => theme.colors.secondary.normal,
                },
            },
        },
        darken: {
            black: {
                fill: {
                    bg: ({ theme }) => theme.colors.grey72,
                    border: ({ theme }) => theme.colors.grey72,
                },
                outline: {
                    border: ({ theme }) => theme.colors.grey72,
                    textColor: ({ theme }) => theme.colors.grey72,
                },
            },
            extra: {
                fill: {
                    bg: ({ theme }) => theme.colors.extra.normal,
                    border: ({ theme }) => theme.colors.extra.normal,
                },
                outline: {
                    border: ({ theme }) => theme.colors.extra.normal,
                    textColor: ({ theme }) => theme.colors.extra.normal,
                },
            },
            secondary: {
                fill: {
                    bg: ({ theme }) => theme.colors.secondary.normal,
                    border: ({ theme }) => theme.colors.secondary.normal,
                },
                outline: {
                    border: ({ theme }) => theme.colors.secondary.normal,
                    textColor: ({ theme }) => theme.colors.secondary.normal,
                },
            },
        },
    },
    padding: {
        small: '4px',
        medium: '6px',
        large: '8px',
    },
};
export const IconColorHook = ({ variant, color, skin }) => {
    const { colors } = useContext(ThemeContext);
    const chipIconConfig = {
        skins: {
            lighten: {
                black: {
                    fill: {
                        iconColor: colors.grey72,
                    },
                    outline: {
                        iconColor: colors.grey72,
                    },
                },
                extra: {
                    fill: {
                        iconColor: colors.extra.normal,
                    },
                    outline: {
                        iconColor: colors.extra.normal,
                    },
                },
                secondary: {
                    fill: {
                        iconColor: colors.secondary.normal,
                    },
                    outline: {
                        iconColor: colors.secondary.normal,
                    },
                },
            },
            darken: {
                black: {
                    outline: {
                        iconColor: colors.grey72,
                    },
                },
                extra: {
                    outline: {
                        iconColor: colors.extra.normal,
                    },
                },
                secondary: {
                    outline: {
                        iconColor: colors.secondary.normal,
                    },
                },
            },
        },
    };
    return chipIconConfig.skins[variant][color][skin].iconColor;
};
